import { render } from "./OnboardingView.vue?vue&type=template&id=6a8a4f04"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__